import React from 'react';
import {
  Content,
  ContentHeader,
  Header,
  Link,
  Page,
  SupportButton,
} from '@backstage/core-components';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { TechRadarComponent } from '@backstage-community/plugin-tech-radar';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles(() => ({
  overflowXScroll: {
    overflowX: 'scroll',
  },
}));

export function CompanyTechRadarPage() {
  const config = useApi(configApiRef);
  const c = config.getOptionalConfig('techRadar');
  const classes = useStyles();
  const [searchText, setSearchText] = React.useState('');

  const title = c?.getOptionalString('title') ?? 'Tech Radar';
  const subtitle =
    c?.getOptionalString('subtitle') ??
    'Pick the recommended technologies for your projects';
  const pageTitle = c?.getOptionalString('pageTitle') ?? 'Tech Radar';

  return (
    <Page themeId="tool">
      <Header title={title} subtitle={subtitle} />
      <Content className={classes.overflowXScroll}>
        <ContentHeader title={pageTitle}>
          <Input
            id="tech-radar-filter"
            type="search"
            placeholder="Filter"
            onChange={e => setSearchText(e.target.value)}
          />
          <SupportButton>
            <Typography paragraph>
              Data is sourced from{' '}
              <Link to="https://github.com/moneyforward/backstage/tree/main/config/tech-radar/">
                Backstage Tech Radar Github
              </Link>
              .
              <br />

              <strong>For tech that is not listed here:</strong>
              <ul>
                <li>Too obvious or easy to migrate to other tech</li>
                <li>Too small and specific to few use-cases rather than company-wide</li>
                <li>Not have an company-wide official plan to evaluate or promote for entire company. Some teams may already tried independently.</li>
              </ul>
            </Typography>
          </SupportButton>
        </ContentHeader>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12}>
            <TechRadarComponent
              searchText={searchText}
              width={1500}
              height={800}
            />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
}
